module.exports = __webpack_public_path__ + "static/media/arrow-right.de862de4.svg";